<div class="mvd_nav-tabs">
    <ul class="mvd_nav">
        <ng-template [ngIf]="data && data.length > 0">
            <li role='presentation' *ngFor="let item of data" [attr.aria-expanded]="isSelected(item)" >
                <a role="button" tabindex="item.order + 1" (click)="setSelected(item)">{{item.title}}</a>
            </li>
        </ng-template>
    </ul>
</div>

<ng-container *ngIf="data && data.length > 0">
    <div [hidden]="!selectedMenuItem.inWell" class="well" >
        <ng-container *ngTemplateOutlet="contentTemplate;context:ctx"></ng-container>
    </div>
</ng-container>
